module.exports = __webpack_public_path__ + "static/media/bullet (2).86ccfc9c.svg";